
import { mapState } from 'vuex';
import ProductOptionTypeHelper from '@/mixins/ProductOptionTypeHelper';

export default {
  name: 'AppFilterSectionProductOptionType',
  mixins: [ProductOptionTypeHelper],
  props: {
    selectedProductOptionTypes: { type: Object, default: () => ({}) }
  },
  computed: {
    ...mapState('widget', ['isMobile'])
  },
  created() {
    this.fetchProductOptionTypes({
      fields: ['check_combo_product', 'option_reviews_count_map'].join(',')
    });
  }
};
